import { Component, OnInit } from '@angular/core';
import frenchi18n from '@assets/i18n/fr.json';
import { TranslateModule } from '@ngx-translate/core';
import { ProcessEventFactory } from '@shared/models/processEvents';
import { ProcessEventService } from '@shared/services/process-event.service';
import { TrackerService } from '@shared/services/tracker.service';
import { StoreService } from '@shared/services/store.service';
import { CancelOpenBankingPopinComponent } from '../../../../shared/components/cancel-open-banking-popin/cancel-open-banking-popin.component';

@Component({
  selector: 'app-bank-connection-failure-retry',
  templateUrl: './bank-connection-failure-retry.html',
  standalone: true,
  imports: [TranslateModule, CancelOpenBankingPopinComponent],
})
export class BankConnectionFailureRetryComponent implements OnInit {
  isPopinOpen = false;

  constructor(
    private processEventService: ProcessEventService,
    private tracker: TrackerService,
    private storeService: StoreService
  ) {}

  ngOnInit(): void {
    this.tracker.trackPage({
      taggingPage: 'BANK_CONNECTION_FAILURE_RETRY',
    });
  }

  retryBankConnectionWithOpenBanking() {
    this.tracker.trackClick({
      click: frenchi18n.connect_to_another_bank,
      taggingPage: 'BANK_CONNECTION_FAILURE_RETRY',
    });

    const isWebauthRedirectionGoingToPartner = this.storeService.getVariableOrThrow(
      'IS_WEBAUTH_REDIRECTION_GOING_TO_PARTNER'
    );

    if (!isWebauthRedirectionGoingToPartner) {
      this.processEventService.push(ProcessEventFactory.SpawnGoBackToBankChoiceEvent());
      return;
    }

    this.processEventService.push(ProcessEventFactory.SpawnRetryBankAuthentication());
  }

  retryBankConnectionWithPartner() {
    this.tracker.trackClick({
      click: frenchi18n.come_back_to_classic_form,
      taggingPage: 'BANK_CONNECTION_FAILURE_RETRY',
    });

    this.isPopinOpen = true;
  }

  closePopin() {
    this.isPopinOpen = false;
  }
}
